import type { Family } from "../domain/types.js";
import type { Distractor, Random } from "./types.js";
export function makeDistractors(family: Family, a: number, b: number, answer: number, count: number, random: Random): Distractor[] {
    const options: Distractor[] = [];
    const offer = (value: number, pattern: string) => { if (Number.isInteger(value) && value >= 0 && value <= 9999 && value !== answer && !options.some(d => d.value === value))
        options.push({ value, pattern }); };
    offer(answer + 1, "off-by-one");
    offer(answer - 1, "off-by-one");
    if (family === "mul") {
        offer(a + b, "wrong-operation-addition");
        offer(answer + a, "neighboring-times-table");
        offer(answer - a, "neighboring-times-table");
    }
    if (family === "div") {
        offer(a - b, "wrong-operation-subtraction");
        offer(a * b, "wrong-operation-multiplication");
    }
    if (family === "add") {
        offer(Math.abs(a - b), "wrong-operation-subtraction");
        if (a % 10 + b % 10 >= 10)
            offer(answer - 10, "forgot-to-carry");
    }
    if (family === "sub") {
        offer(a + b, "wrong-operation-addition");
        if (a % 10 < b % 10)
            offer(answer + 10, "forgot-to-borrow");
    }
    if (family === "missing")
        offer(a + b, "wrong-operation-addition");
    offer(Number(String(answer).split("").reverse().join("")), "reversed-digits");
    if (answer >= 10) {
        offer(answer + 10, "off-by-ten");
        offer(answer - 10, "off-by-ten");
    }
    for (let i = 0; options.length < Math.max(10, count * 3) && i < 100; i++)
        offer(random.int(0, Math.max(12, answer + 25)), "other");
    for (let i = 0; options.length < count; i++)
        offer(i, "other");
    if (count <= 2)
        options.sort((x, y) => Number(String(x.value)[0] === String(answer)[0]) - Number(String(y.value)[0] === String(answer)[0]));
    return options.slice(0, count);
}
export function shuffled<T>(items: T[], random: Random): T[] { const result = [...items]; for (let i = result.length - 1; i > 0; i--) {
    const j = random.int(0, i);
    [result[i], result[j]] = [result[j], result[i]];
} return result; }
